// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"30a545cd","665":"9e0b33ee","889":"59b4ca5d"}[chunkId] + ".chunk.js";
};